import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";

interface IFileTypeAttachment extends IExportableFile {
    AttachmentId: string;
    FromPatientDocId?: string;
    FromPatientDocType?: FileType;
    radPdfFormId?: string;
}

class FileTypeAttachment extends ExportableFile implements IFileTypeAttachment {
    public AttachmentId: string;
    public FromPatientDocId?: string; // original File
    public FromPatientDocType?: FileType;// original File
    public radPdfFormId?: string;

    constructor(fields: IFileTypeAttachment) {
        super(FileType.ATTACHMENT);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string {
        return this.AttachmentId;
    }

    public getCleanCopy(): FileTypeAttachment {
        return new FileTypeAttachment({
            AttachmentId: this.AttachmentId,
            FromPatientDocId: this.FromPatientDocId,
            FromPatientDocType: this.FromPatientDocType,
            date: this.date,
            description: this.description
        });
    }

    public async getMeta(): Promise<number> {
        throw "Not implemented";
    }

    protected generateFileIfNeeded(): Promise<IExportableFileLoaded> {
        if (this.AttachmentId) {
            const fetchUrl = FileSelectionHelper.getFetchUrl(this.AttachmentId, this.fileType, { noCache: true });

            return new Promise(resolve => resolve({
                OriginalExportableFile: this,
                FetchUrl: fetchUrl
            }));
        }
        else {
            // not saved yet, show original file
            const fetchUrl = FileSelectionHelper.getFetchUrl(this.FromPatientDocId, this.FromPatientDocType, { noCache: true });

            return new Promise(resolve => resolve({
                OriginalExportableFile: this,
                FetchUrl: fetchUrl
            }));
        }
    }
}

export { FileTypeAttachment };
